module.exports = __webpack_public_path__ + "static/screen-android-mobile-355cc6f556cc81241027c2003dc3a658.webp";